<template>
    <div class="testPaper">
        <Header></Header>
        <div class="container testPaperBox" v-if="testPaperData">
            <h2>{{ testPaperData.testName }}</h2>
            <h3 class="score">{{`共得分：${testPaperData.totalScore? testPaperData.totalScore : 0}分`}}</h3>
            <div class="singleQuestions" v-if="testPaperData.singleChoiceQuestionNum">
                <h3>{{`单选题（共 ${testPaperData.singleChoiceQuestionNum} 道题）`}}</h3>
                <div class="singleQuestionsBox">
                    <div
                     class="questions"
                     v-for="(single, index) in testPaperData.singleChoiceQuestions"
                     :key="index">
                        <i class="el-icon-check" v-if="single.checkStatus == '正确'"></i>
                        <i class="el-icon-close" v-else></i>
                        <div>
                            <div class="questionsTitle">
                                <span>{{ `${index + 1}.` }}</span>
                                <span v-html="` ${single.title}`" class="title"></span>
                                <span>{{`（得分：${single.getQuestionScore? single.getQuestionScore : 0}分）`}}</span>
                            </div>
                            <div class="singleOption">
                                <span
                                 :class="option.isSelect? 'colorCheck' : ''"
                                 v-for="(option, optionIndex) in single.options"
                                 :key="optionIndex"
                                 v-html="`${optionMap[optionIndex]}.${option.option}`"></span>
                            </div>
                            <div v-if="single.checkStatus == '错误'">
                                <span
                                 class="successAnswer"
                                 v-for="(option, optionIndex) in single.options"
                                 :key="optionIndex"
                                 v-show="option.id == single.optionId">{{ `正确答案：${optionMap[optionIndex]}` }}</span>
                            </div>
                            <div class="analysis">{{ `【解析】：${single.description}` }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="multipleQuestions" v-if="testPaperData.multipleChoiceQuestionNum">
                <h3>{{`多选题（共 ${testPaperData.multipleChoiceQuestionNum} 道题）`}}</h3>
                <div class="multipleQuestionsBox">
                    <div
                     class="questions"
                     v-for="(multiple, index) in testPaperData.multipleChoiceQuestions"
                     :key="index">
                        <i class="el-icon-check" v-if="multiple.checkStatus == '正确'"></i>
                        <i class="el-icon-close" v-else></i>
                        <div>
                            <div class="questionsTitle">
                                <span>{{ `${index + 1}.` }}</span>
                                <span v-html="`${multiple.title}`"></span>
                                <span>{{`（得分：${multiple.getQuestionScore? multiple.getQuestionScore : 0}分）`}}</span>
                            </div>
                            <div class="multipleOption">
                                <span
                                :class="option.isSelect? 'colorCheck' : ''"
                                v-for="(option, optionIndex) in multiple.options"
                                :key="optionIndex"
                                v-html="`${optionMap[optionIndex]}.${option.option}`"></span>
                            </div>
                            <span
                             v-if="multiple.checkStatus == '错误'"
                             class="successAnswer">{{ `正确答案：${multiple.succeedOption.join(" ")}` }}</span>
                            <div class="analysis">{{ `【解析】：${multiple.description}` }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="gapFillingQuestions" v-if="testPaperData.gapFillingQuestionNum">
                <h3>{{`填空题（共 ${testPaperData.gapFillingQuestionNum} 道题）`}}</h3>
                <div class="judgeQuestionsBox">
                    <div
                     class="questions"
                     v-for="(gapFilling, index) in testPaperData.gapFillingQuestions"
                     :key="index">
                        <i class="el-icon-check" v-if="gapFilling.checkStatus == '正确'"></i>
                        <i class="el-icon-close" v-else></i>
                        <div>
                            <div class="questionsTitle">
                                <span>{{ `${index + 1}.` }}</span>
                                <span v-html="`${gapFilling.title}`"></span>
                                <span>{{`（得分：${gapFilling.getQuestionScore? gapFilling.getQuestionScore : 0}分）`}}</span>
                            </div>
                            <div class="judgeOption">
                                <span
                                v-for="(option, gapFillingIndex ) in gapFilling.stuGapFilling"
                                :key="gapFillingIndex">{{`填空${gapFillingIndex+1}：${option}`}}</span>
                            </div>
                            <div
                             class="judgeSuccessAnswer"
                             v-if="gapFilling.checkStatus == '错误'"
                             >
                                <span>正确答案：</span>
                                <span
                                 v-for="(suitem, suIndex) in gapFilling.gapFilling"
                                 :key="suIndex">{{ `填空${suIndex + 1}: ${suitem[0]}` }}</span>
                            </div>
                            <div class="analysis">{{ `【解析】：${gapFilling.description}` }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="judgeQuestions" v-if="testPaperData.judgeQuestionNum">
                <h3>{{`判断题（共 ${testPaperData.judgeQuestionNum} 道题）`}}</h3>
                <div class="judgeQuestionsBox">
                    <div
                     class="questions"
                     v-for="(judge, index) in testPaperData.judgeQuestions"
                     :key="index">
                        <i class="el-icon-check" v-if="judge.checkStatus == '正确'"></i>
                        <i class="el-icon-close" v-else></i>
                        <div>
                            <div class="questionsTitle">
                                <span>{{ `${index + 1}.` }}</span>
                                <span v-html="`${judge.title}`"></span>
                                <span>{{`（得分：${judge.getQuestionScore? judge.getQuestionScore : 0}分）`}}</span>
                            </div>
                            <div class="judgeOption">
                                <i class="el-icon-circle-check" :class="judge.stuAnswer == '正确'? 'colorCheck' : ''"></i>
                                <i class="el-icon-circle-close" :class="judge.stuAnswer == '错误'? 'colorCheck' : ''"></i>
                            </div>
                            <span
                             class="successAnswer"
                             v-if="judge.checkStatus == '错误'">正确答案：<i :class="judge.answer == '正确'? 'el-icon-circle-check' : 'el-icon-circle-close'"></i></span>
                            <div class="analysis">{{ `【解析】：${judge.description}` }}</div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="comprehensiveQuestions" v-if="testPaperData.comprehensiveQuestionNum">
                <h3>{{`问答题（共 ${testPaperData.comprehensiveQuestionNum} 道题）`}}</h3>
                <div class="comprehensiveQuestionsBox">
                    <div
                     v-for="(comprehensive, index) in testPaperData.comprehensiveQuestions"
                     :key="index">
                        <span class="questionsBox" v-html="`${index + 1}. ${comprehensive.title}`"></span>
                        <div class="judgeOption">
                            <el-input
                             type="textarea"
                             :autosize="{ minRows: 10}"
                             resize="none"
                             :disabled="true"
                             v-model="comprehensive.stuAnswer">
                            </el-input>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <Foot></Foot>
    </div>
</template>
<script>
import Header from '@/components/header';
import Foot from '@/components/foot';
import testPaperApi from '@/request/api/testPaper';

export default {
    components: {
        Header,
        Foot
    },
    data() {
        return {
            testPaperId: "",
            testPaperData: null,
            optionMap: ['A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I']
        }
    },
    created() {
        this.getTestPaper();
    },
    methods: {
        //查看试卷
        getTestPaper() {
            if(this.$route.query && this.$route.query.id) {
                this.testPaperId = this.$route.query.id
                testPaperApi.findTestPaper(this.testPaperId, res => {
                    if(res.succeed) {
                        this.testPaperData = res.data;
                        //循环答案
                        if(this.testPaperData && this.testPaperData.multipleChoiceQuestions) {
                            this.testPaperData.multipleChoiceQuestions.forEach((questions, questionsIndex) => {
                                let arr = [];
                                this.testPaperData.multipleChoiceQuestions[questionsIndex].optionIds.forEach((item, index) => {
                                    for(var i = 0; i < this.testPaperData.multipleChoiceQuestions[questionsIndex].options.length; i++) {
                                        if(item == this.testPaperData.multipleChoiceQuestions[questionsIndex].options[i].id) {
                                            arr.push(this.optionMap[i]);
                                        }    
                                    }
                                    this.$set(this.testPaperData.multipleChoiceQuestions[questionsIndex], 'succeedOption', arr);
                                })
                            });
                        }
                    }
                })
            }
        }
    }
}
</script>
<style scoped>
.testPaperBox {
    padding: 15px 10%;
    margin: 15px auto;
    background: #fff;
    border-radius: 5px;
    box-shadow: 0 15px 15px rgba(0,0,0,.2);
}
.el-icon-check {
    color: green;
    font-size: 20px;
    font-weight: 600;
    margin-right: 5px;
}
.el-icon-close {
    color: red;
    font-size: 20px;
    font-weight: 600;
    margin-right: 5px;
}
h2 {
    text-align: center;
}
.score {
    text-align: right;
}
.questions {
    display: flex;
    flex-direction: row;
    width: 100%;
}
.questions .analysis {
    padding: 5px;
}
.questionsTitle {
    display: flex;
    flex-direction: row;
}
.questionsTitle span:nth-child(1) {
    margin-right: 5px;
}
.questionsTitle span:nth-child(2) {
    display: flex;
    flex-direction: column;
}
.questionsTitle span:nth-child(3) {
    white-space: nowrap;
}
.successAnswer {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: baseline;
    padding: 5px 0;
    font-weight: 500;
    color: green;
}
.judgeSuccessAnswer {
    display: flex;
    flex-direction: column;
    color: green;
    font-weight: 500;
}
.judgeSuccessAnswer span {
    font-weight: 500;
}
.judgeSuccessAnswer span:nth-child(2),
.judgeSuccessAnswer span:nth-child(3) {
    text-indent: 1em;
}
span {
    display: flex;
    font-size: 17px;
    font-weight: 600;
    letter-spacing: 1px;
}
.singleOption span,
.multipleOption span {
    text-indent: 1em;
    font-size: 13px;
    font-weight: 500;
}
.judgeOption i,
.judgeOption span {
    text-indent: 1em;
    font-weight: 500;
}
.colorCheck {
    color: #0080FF;
}
.judgeOption i {
    font-size: 22px;
}
.questionsBox {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: baseline;
}
</style>


// WEBPACK FOOTER //
// src/components/testPaper.vue